/**
 * WooCommerce Cart Updates
 * 
 * Handles cart count updates and cart fragment updates
 */

class WooCommerceCart {
	constructor() {
		this.init();
	}
	
	init() {
		// Update cart count on page load
		this.updateCartCount();
		
		// Listen for cart updates (WooCommerce cart fragments)
		if (typeof wc_add_to_cart_params !== 'undefined') {
			document.body.addEventListener('added_to_cart', () => {
				this.updateCartCount();
			});
		}
		
		// Listen for cart updates via custom events
		document.body.addEventListener('wc_fragment_refresh', () => {
			this.updateCartCount();
		});
		
		// Update cart count periodically (fallback)
		setInterval(() => {
			this.updateCartCount();
		}, 5000);
	}
	
	updateCartCount() {
		if (typeof WC === 'undefined' || !WC.cart) {
			return;
		}
		
		const cartCount = WC.cart.get_cart_contents_count();
		const cartCountElements = document.querySelectorAll('[data-cart-count]');
		
		cartCountElements.forEach(element => {
			if (cartCount > 0) {
				element.textContent = cartCount;
				element.style.display = 'flex';
			} else {
				element.textContent = '';
				element.style.display = 'none';
			}
		});
	}
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		if (typeof WC !== 'undefined') {
			new WooCommerceCart();
		}
	});
} else {
	if (typeof WC !== 'undefined') {
		new WooCommerceCart();
	}
}

export default WooCommerceCart;
